import { getParticipantVoteView, getRosterIdentityMode } from "../../../lib/vote-visibility";

// Maps one accepted participant (its RAW status object + its display/aliased twin) to a
// render-ready roster row. STATUS is read from the RAW object so aliasing (which scrubs
// hasVoted) can never strip it. Pending invites carry roster identity but NO vote status.
export function buildSchedulerRosterRow({
  rawMember,
  displayMember,
  currentUser,
  viewer,
  settings,
  pollState,
  statusKnown,
}) {
  const displayUser = displayMember || rawMember;
  if (rawMember?.isPendingInvite) {
    return {
      displayUser,
      isPendingInvite: true,
      bubbleMode: "named",
      rosterName: getRosterIdentityMode({
        isCreator: !!viewer?.isCreator,
        isSelf: false,
        voteAnonymization: settings?.voteAnonymization,
      }),
      showStatus: false,
      statusKnown: false,
      statusValue: "unknown",
      statusLabel: "Pending invite",
      canOpenIdentityActions: false,
    };
  }
  const view = getParticipantVoteView({
    currentUser,
    viewer,
    target: { user: rawMember, hasVoted: !!rawMember?.hasVoted, statusKnown },
    settings,
    pollState,
  });
  const statusLabel = !view.showStatus
    ? "Hidden"
    : !view.statusKnown
      ? "—" // em dash — never assert Pending when unknown
      : view.statusValue === "voted"
        ? "Voted"
        : "Pending";
  return {
    displayUser,
    isPendingInvite: false,
    bubbleMode: view.bubbleMode,
    rosterName: view.rosterName,
    showStatus: view.showStatus,
    statusKnown: view.statusKnown,
    statusValue: view.statusValue,
    statusLabel,
    canOpenIdentityActions: view.canOpenIdentityActions,
  };
}
